import { IconContent } from '@icons';

export const listView: IconContent = {
    sm: '<path d="M4 5H3V4h1v1ZM3 8.5h1v-1H3v1ZM13 7.5H6v1h7v-1ZM13 4H6v1h7V4ZM6 11h7v1H6v-1ZM3 12h1v-1H3v1Z" />',
    md: '<path d="M6 6.5H4v1h2v-1Zm0 5H4v1h2v-1Zm-2 5h2v1H4v-1Zm16-10H8v1h12v-1Zm-12 5h12v1H8v-1Zm12 5H8v1h12v-1Z" />',
};
